<div class="myH_forecast">
  <div class="row">
    <div class="col-lg-6 mt-3">
      <h5>Cash-Out Refinance</h5>
      <ul>
        <li>
          You can take up to <b>{{ isPositive(cashOut) | currency: 'USD':'symbol':'0.0-0' }}</b> cash from your home
        </li>
        <li>
          All your home loans usually cannot exceed
          <b>
            <mat-form-field class="col-2 col-md-1 px-0 text-center">
              <strong
                ><input
                  matInput
                  type="number"
                  name="ltvRate"
                  [(ngModel)]="ltvRate"
                  (input)="calculateTradeLimitOnLTVRateChange(); cashOutRefinance($event)"
                  autocomplete="off"
              /></strong> </mat-form-field
            >%</b
          >
          of your home value
        </li>
        <li>This is also called Loan-To-Value ratio (LTV)</li>
      </ul>
      <h5 class="mt-4">Buy a Second Home</h5>
      <ul>
        <li>Use your equity as down payment to buy a second home</li>
        <li>
          With <b>25%</b> down payment, you can buy a second home for up to
          <b>{{ isPositive(addOnLimit) | currency: 'USD':'symbol':'0.0-0' }}</b>
        </li>
        <li class="link" *ngIf="source != 'fromEquiltyAnalysis'">
          <a href="#" (click)="buySecondHomeArticleSheet(); $event.preventDefault()">
            Learn how to use your equity to buy a second home
          </a>
        </li>
      </ul>
      <h5 class="mt-4">Trade Up for a Larger Home</h5>
      <ul>
        <li>Buy a new home using the cash from selling your home.</li>
        <li>
          You could collect up to <b>{{ currentEquity | currency: 'USD':'symbol':'0.0-0' }}</b> from selling your home.
        </li>
        <li>
          Using that as <b>20%</b> down payment, you can buy a home for up to
          <b>{{ isPositive(tradeUpLimit) | currency: 'USD':'symbol':'0.0-0' }}</b>
        </li>
      </ul>
    </div>
    <div class="col-lg-5 d-none d-sm-flex align-items-center">
      <img class="img-fluid mx-auto" src="../../../assets/images/home equity.svg" /><br />
    </div>
  </div>
</div>
